import { render, staticRenderFns } from "./budget-header-new-1.vue?vue&type=template&id=8953fb64&scoped=true&"
import script from "./budget-header-new-1.vue?vue&type=script&lang=ts&"
export * from "./budget-header-new-1.vue?vue&type=script&lang=ts&"
import style0 from "./budget-header-new-1.vue?vue&type=style&index=0&id=8953fb64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8953fb64",
  null
  
)

export default component.exports